import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Dialog, DialogTitle, DialogContent, CircularProgress, Fade, DialogActions, Grid } from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import FileUpload from "../Files/Upload";
import PrimaryButton from "../Global/Buttons/PrimaryButton";
import { downloadProperties, uploadProperties } from "../../store/state/properties";
import SecondaryButton from "../Global/Buttons/SecondaryButton";

const Spacer = styled.div`
  flex-grow: 1;
`;

const Description = styled.div`
  /* Work Sans / 14 Regular */
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: flex-end;

  /* Text / Black */
  color: #000000;
  padding-bottom: 15px;
`;

const ValidationGrid = styled(Grid)`
  && {
    height: 264px;
  }
`;

const ValidationComment = styled.div`
  color: rgba(0, 0, 0, 0.537);
`;

const StyledCancelButton = styled(PrimaryButton)`&&& {
    /* Work Sans / 14 Medium */
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
        
    /* or 18px */
    display: flex;
    align-items: center;
    text-align: center;    
    
    /* Text / LB Blue */
    color: #ffffff

    margin-right: 12px;
  }
`;

export const VerticalDivider = styled.div`
  height: 100%;
  border-right: 1px solid #cccccc;
`;

const Error = styled.div`
  color: #ff0000;
  font-size: 17px;
  padding-left: 8px;
`;

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
`;

const DownloadButton = styled(SecondaryButton)`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: flex-end;

    /* LB Blue Dark */
    color: #005AA9;

    padding: 0px;
    margin-top: -30px;
    margin-bottom: 15px;
  }
`;

const styles = () => ({
  customPaperWidthMd: {
    maxWidth: "780px",
    minWidth: "750px"
  }
});

class UploadSpreadsheetModal extends Component {
  onClose = () => {
    this.props.onClose();
  };

  render() {
    const { classes, isOpen, errorMessage, showSpinner } = this.props;
    return (
      <Dialog
        classes={{
          paperWidthMd: classes.customPaperWidthMd
        }}
        open={isOpen}
        onClose={this.onClose}
        maxWidth="md"
      >
        <Grid container alignItems="center" justify="space-between">
          <DialogTitle>Edit Properties</DialogTitle>
          <IconButton style={{ marginRight: 16 }} onClick={this.onClose}>
            <CloseIcon style={{ fontSize: 36 }} />
          </IconButton>
        </Grid>
        <DialogContent>
          {!showSpinner && (
            <Grid container spacing={8} justify="space-between">
              <Grid item container xs={5}>
                <Description>1. Download the current property details below:</Description>
                <DownloadButton onClick={() => this.props.downloadProperties(this.props.selectedPropertyIds)}>Property Details Spreadsheet</DownloadButton>
                <Description>2. Edit the downloaded spreadsheet.</Description>
              </Grid>
              <Grid>
                <VerticalDivider />
              </Grid>
              <Grid item container xs={5}>
                <Description>3. Upload the edited spreadsheet:</Description>
                <FileUpload onDrop={files => this.props.uploadProperties({ file: files[0] })} />
              </Grid>
            </Grid>
          )}
          {showSpinner && (
            <ValidationGrid direction="column" container justify="center" alignItems="center" spacing={16}>
              <Grid item>
                <CircularProgress size={120} thickness={1} />
              </Grid>
              <Grid item>
                <ValidationComment>Validating file...</ValidationComment>
              </Grid>
            </ValidationGrid>
          )}
        </DialogContent>
        <StyledDialogActions>
          <Fade in={!!errorMessage}>
            <Error>{errorMessage}</Error>
          </Fade>
          <Spacer />
          <StyledCancelButton onClick={this.onClose}>Cancel</StyledCancelButton>
        </StyledDialogActions>
      </Dialog>
    );
  }
}

UploadSpreadsheetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedPropertyIds: PropTypes.array.isRequired
};

const mapStateToProps = ({ properties }) => ({
  errorMessage: properties.uploadErrorMessage,
  showSpinner: properties.showSpinner
});

export default compose(withRouter, connect(mapStateToProps, { downloadProperties, uploadProperties }), withStyles(styles))(UploadSpreadsheetModal);
